import { format as _format, parse } from 'date-fns';
import moment from 'moment-timezone';

/**
  Return the formatted date string in the given format.
  https://date-fns.org/v2.25.0/docs/format
*/
type NamedArgs = { parseFormat?: string };
export default function dateFormat(
  date: Date | string | moment.Moment,
  format: string,
  options: object = {},
  { parseFormat }: NamedArgs = {},
): string {
  let _date: Date;

  // TODO: remove this if we don't use moment anymore
  if (moment.isMoment(date)) {
    _date = date.toDate();
  } else if (typeof date === 'string') {
    _date = typeof parseFormat === 'string' ? parse(date, parseFormat, new Date(), options) : new Date(date);
  } else {
    _date = date ?? new Date();
  }

  // Beware: invalid date strings will not parse to a valid date; date-fns will throw an error when trying to format one
  return isNaN(_date.getTime()) ? '' : _format(_date, format, options);
}
